module.exports = __webpack_public_path__ + "img/4.758f31b0.png";